import styled, { css } from "styled-components";
//MISC
import { BORDER_RADIUS, COLORS, SIZE } from "constants/variables";
import { ProjectCardType } from "./ProjectCardModel";

//ASSETS
import cursorIcon from "assets/img/Cursor.png";

export const ProjectCardContainer = styled.div<{ type: ProjectCardType }>`
  width: 100%;
  max-width: ${SIZE.max480};
  height: 100%;
  border-radius: ${BORDER_RADIUS.radius24};
  position: relative;
  border: 1px solid ${COLORS.AbsoluteWhite}b3;
  @media (max-width: 768px) {
    height: ${SIZE.max550};
  }

  ${({ type }) =>
    type === ProjectCardType.PROJECTS_PAGE &&
    css`
      max-width: 100%;
      height: 100%;
    `}&::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 0.4) 40%,
      rgba(0, 0, 0, 0) 100%
    );
    pointer-events: none;
    border-radius: inherit;
  }
`;

export const ProjectCardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.Background};
  ${ProjectCardContainer}:hover & {
    cursor: ${({ biggerCursor }) =>
      biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
    filter: brightness(0.8);
    transition: filter 0.3s ease-out;
  }
`;

export const TextWrapper = styled.div`
  width: 100%;
  position: absolute;
  bottom: ${SIZE.max40};
  padding: 0 ${SIZE.max40};
  text-overflow: ellipsis !important;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  color: ${COLORS.Cultured};
  max-height: 90px;
  z-index: 2;
  @media (max-width: 768px) {
    left: ${SIZE.max24};
    bottom: ${SIZE.max24};
    width: calc(100% - ${SIZE.max40});
    -webkit-line-clamp: 2;
  }
`;
